import { createFileRoute } from '@tanstack/react-router';
import { SetupSettingsStep } from '@/pages/workspaces/transactional/message/setup/settings-step/setup-settings-step';
import { withRumPageRendered } from '@/services/rum/use-page-rendered';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/setup/settings',
)({
  component: withRumPageRendered(SetupSettingsStep),
});
